//Utilities
import snackbar from "node-snackbar/dist/snackbar";
import "node-snackbar/dist/snackbar.css";

const showNotify = (settings) => {
  if (settings) {
    return snackbar.show({
      actionText: "بستن",
      showAction: settings.showAction ? settings.showAction : false,
      pos: settings.pos ? settings.pos : window.innerWidth <= 768 ? "top-center" : "bottom-center",
      ...settings,
    });
  }
};
// customClass: "error", "success",

export const closeNotify = () => snackbar.close();

export default showNotify;
